import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class StopWinState extends BaseState {
    constructor(stateData) {
        super(stateData);

        this.timeout = null;
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('bigWinContainer:nextState', this.stopNow, this);
    }

    stopNow() {
        if (this.active) {
            this.complete();
        }
    }
}
